// react
import { useEffect, useState } from 'react';

function getStorageValue(key, defaultValue) {
  // getting stored value
  const saved = localStorage.getItem(key);

  let initial = defaultValue;
  try {
    if (saved) {
      initial = JSON.parse(saved);
    }
  } catch (e) {
    console.error('Error parsing JSON from localStorage', e);
  }

  return initial;
}

export const useLocalStorageJson = (key, defaultValue) => {
  const [value, setValue] = useState(() => {
    return getStorageValue(key, defaultValue);
  });

  useEffect(() => {
    // storing input name
    localStorage.setItem(key, JSON.stringify(value));
  }, [key, value]);

  return [value, setValue];
};
